import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Import Api files
import {
  editCurrentUserApi,
  forgetPasswordApi,
  getCurrentUserApi,
  postUserLogin,
  updatePasswordApi,
  verifyUserApi,
} from "../../api/users";

// Login Redux States
import {
  CURRENT_USER,
  FORGET_PASSWORD,
  LOGIN_USER,
  LOGOUT_USER,
  UPDATE_CURRENT_USER,
  UPDATE_PASSWORD,
  VERIFY_USER,
} from "./actionTypes";
import {
  apiError,
  forgetPasswordFailure,
  forgetPasswordSuccess,
  getCurrentUserFailure,
  getCurrentUserSuccess,
  loginFailure,
  loginSuccess,
  logoutUserSuccess,
  updateCurrentUserFailure,
  updateCurrentUserSuccess,
  updatePasswordFailure,
  updatePasswordSuccess,
  verifyUserFailure,
  verifyUserSuccess,
  getCurrentUser,
} from "./actions";

function* loginUser({ payload }) {
  try {
    const { data } = yield call(postUserLogin, payload);
    yield put(loginSuccess(data));
    localStorage.setItem("token", data.token);
    localStorage.setItem("email", data.email);
  } catch (error) {
    console.log(error);
    yield put(loginFailure(error.response.data.message));
    yield payload.toast.error(error.response.data.message);
  }
}

// ===================================================
// ===================================================

function* logoutUser() {
  try {
    yield put(logoutUserSuccess());
    localStorage.removeItem("token");
    localStorage.removeItem("store");
  } catch (error) {
    yield put(apiError(error.response.data.errors[0].msg));
  }
}

// ===================================================
// ===================================================

function* currentUserSaga() {
  try {
    const { data } = yield call(getCurrentUserApi);
    yield put(getCurrentUserSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getCurrentUserFailure(error.response.data.message || error));
  }
}

// ===================================================
// ===================================================

function* updateCurrentUserSaga({ payload }) {
  try {
    const { data } = yield call(editCurrentUserApi, payload);
    yield put(updateCurrentUserSuccess(data));
  } catch (error) {
    yield put(updateCurrentUserFailure(error.response.data.message || error));
    yield payload.toast.error(error.response.data.message || error);
  }
}

// ===================================================
// ===================================================

function* updatePasswordSaga({ payload }) {
  try {
    const { data, success, message } = yield call(updatePasswordApi, payload);
    yield put(updatePasswordSuccess(data));
    if (success === "true") {
      yield payload.toast.success(message);
      yield payload.navigate("/");
    }
  } catch (error) {
    yield put(updatePasswordFailure(error.response.data.message || error));
    yield payload.toast.error(error.response.data.message || error);
  }
}

// ===================================================
// ===================================================

function* verifyUserSaga({ payload }) {
  try {
    const { data, success, message } = yield call(verifyUserApi, payload);
    yield put(verifyUserSuccess(data));

    if (success || success === "true") {
      yield payload?.toast.success(message);
      localStorage.setItem("token", data.token);
      yield payload?.dispatch(getCurrentUser());
      yield payload?.navigate("/change-password");
    }
  } catch (error) {
    console.log(error.response);
    yield put(
      verifyUserFailure(error.response?.data?.message[0]?.msg || error)
    );
    yield payload.toast.error("من فضلك تأكد من الكود المدخل وحاول مرة أخرى!");
  }
}

// ==================================================
// ==================================================

function* forgetPasswordSaga({ payload }) {
  try {
    const { data, success, message } = yield call(forgetPasswordApi, payload);
    yield put(forgetPasswordSuccess(data));

    if (success || success === "true") {
      yield payload?.toast.success(message);
      yield payload?.navigate("/reset-password");
    }
  } catch (error) {
    console.log(error);
    yield put(forgetPasswordFailure(JSON.stringify(error)));
    yield payload.toast.error(error.response?.data?.message || error);
  }
}

// ==================================================
// ==================================================

export function* watchUserLogin() {
  yield takeEvery(LOGIN_USER, loginUser);
}

export function* watchUserLogout() {
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export function* watchCurrentUser() {
  yield takeEvery(CURRENT_USER, currentUserSaga);
}

export function* watchUpdateCurrentUser() {
  yield takeEvery(UPDATE_CURRENT_USER, updateCurrentUserSaga);
}

export function* watchUpdatePassword() {
  yield takeEvery(UPDATE_PASSWORD, updatePasswordSaga);
}

export function* watchVerifyUser() {
  yield takeEvery(VERIFY_USER, verifyUserSaga);
}

export function* watchForgetPassword() {
  yield takeEvery(FORGET_PASSWORD, forgetPasswordSaga);
}

// ===================================================
// ===================================================

function* authSaga() {
  yield all([fork(watchUserLogin)]);
  yield all([fork(watchUserLogout)]);
  yield all([fork(watchCurrentUser)]);
  yield all([fork(watchUpdateCurrentUser)]);
  yield all([fork(watchUpdatePassword)]);
  yield all([fork(watchVerifyUser)]);
  yield all([fork(watchForgetPassword)]);
}

export default authSaga;
